import React from 'react'
import importer from 'common/importer'
const CustomPage = importer('Components/CustomPage')

const CustomPageContainer = () => {
  return <CustomPage />
}

export default CustomPageContainer
